/**
 * Processes a matrix of data using the first row as headers.
 * Extracts property sets with their names, dates, and associated units.
 *
 * @param matrix - A 2D array where each row represents a property unit.
 * @returns An array of objects, each representing a property set with its name, date, and units.
 */
function processAllSets(matrix: (string | number | null)[][]): {
  name: string;
  date: string;
  units: (string | number)[][];
}[] {
  if (matrix.length < 2) return []; // Ensure matrix has data beyond headers

  const headers = matrix[0]; // First row contains column names
  const nameIndex = headers.indexOf("Nombre de conjunto");
  const dateIndex = headers.indexOf("Fecha de entrega");
  const unitStartIndex = 3; // Units start after "Nombre de conjunto" and "Fecha de entrega"

  if (nameIndex === -1 || dateIndex === -1) {
    throw new Error("Missing required columns in the header.");
  }

  const sets: { name: string; date: string; units: (string | number)[][] }[] = [];
  let currentSet: {
    name: string;
    date: string;
    units: (string | number)[][];
  } | null = null;

  // Process each row, ignoring the header row
  for (let i = 1; i < matrix.length; i++) {
    const row = matrix[i];
    const setName = row[nameIndex];
    const date = row[dateIndex];

    // If a new set name and date are found, start a new set
    if (setName && date) {
      currentSet = {
        name: setName as string,
        date: date as string,
        units: []
      };
      sets.push(currentSet);
    }

    // If there is unit data and a current set exists, add the unit data
    if (currentSet) {
      currentSet.units.push(row.slice(unitStartIndex) as (string | number)[]);
    }
  }

  return sets;
}
export { processAllSets };
// // Example input matrix (with headers)
// const matrix: (string | number | null)[][] = [
//   [null, "Nombre de conjunto", "Fecha de entrega", "Nombre unidad", "Metros solar", "Tipo moneda", "Precio venta"],
//   [null, "Terreno A", "2024-02-01T00:00:00.000Z", "A1", 0, "RD", 0],
//   [null, null, null, "A2", 0, "RD", 0],
//   [null, null, null, "A3", 0, "RD", 0],
//   [null, null, null, "A4", 0, "RD", 0],
//   [null, "Terreno B", "2025-11-08T00:00:00.000Z", "B3", 0, "RD", 0],
//   [null, null, null, "B2", 0, "RD", 0],
//   [null, null, null, "B3", 0, "RD", 0],
//   [null, null, null, "B4", 0, "RD", 0]
// ];

// // Process data and log output
// console.log(JSON.stringify(processAllSets(matrix), null, 2));
